import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class GetVehicleTypeCommand extends IRequestCommand<
  string,
  ErrorDetails,
  IGetVehiclesTypeCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'vehicles/{carrierId}/types';

  public override setParameters(parameters: IGetVehiclesTypeCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId
    );
    if (parameters.carrierHasCars) {
      this._commandUrl = this._commandUrl.concat('?carrierHasCars=true')
    }
    if (parameters.serviceTypeId) {
      this._commandUrl = 
        this._commandUrl.concat(
          parameters.carrierHasCars ? 
            '&serviceTypeId='+parameters.serviceTypeId.toString()+'&isProgrammed=true' : 
            '?serviceTypeId='+parameters.serviceTypeId.toString()+'&isProgrammed=true'
          );
    }
  }
}

export interface IGetVehiclesTypeCommandParameters extends ICommandParameters {
  carrierId?: string;
  carrierHasCars?: boolean;
  serviceTypeId?: any;
}
